// extracted by mini-css-extract-plugin
export default {"roleLabel":"yzvCKUQw"};